export default __webpack_public_path__ + "static/media/ic_invoices.0f0dce65.svg";